import { configureStore, Action } from "@reduxjs/toolkit";
import { ThunkAction } from "redux-thunk";
// Or from '@reduxjs/toolkit/query/react'
import { setupListeners } from "@reduxjs/toolkit/query";
import { errorMiddleware } from "../services/errorMiddleware";
import { resourceGroupApi } from "../services/resourceGroups/resourceGroupApi";
import { graphApi } from "../services/msgraph/msGraphApi";
import { subscriptionApi } from "../services/resourceGroups/subscriptionApi";
import { tenantAPi } from "../services/resourceGroups/tenantApi";
import { userApi } from "../services/users/userApi";
import { objectsApi } from "../services/objects/objectsApi";

const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [graphApi.reducerPath]: graphApi.reducer,
    [resourceGroupApi.reducerPath]: resourceGroupApi.reducer,
    [subscriptionApi.reducerPath]: subscriptionApi.reducer,
    [tenantAPi.reducerPath]: tenantAPi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [objectsApi.reducerPath]: objectsApi.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(errorMiddleware)
      .concat(graphApi.middleware)
      .concat(resourceGroupApi.middleware)
      .concat(subscriptionApi.middleware)
      .concat(tenantAPi.middleware)
      .concat(userApi.middleware)
      .concat(objectsApi.middleware),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;

export default store;
